import React from "react";
import { InlineRadioButton } from "@graffer-inc/console-design-kit";
import { Icons } from "../../../atoms/icon";
import "./search-filter.scss";
import { useSearchFilterController } from "./use-search-filter-controller";
import { Product, Tag } from "../../../../application/domain/help/help-entity";

export type SearchFilterProps = {
  selectedProductId?: string;
  selectedTags: string[];
  productList: Product[];
  tagList: Tag[];
  onChangeProduct: (productId: string) => void;
  onChangeTags: (tags: string[]) => void;
};

export const SearchFilter: React.FC<SearchFilterProps> = (props) => {
  const {
    productList,
    selectedProductId,
    selectedTags,
    handleOnProductChange,
    handleOnTagChange,
  } = useSearchFilterController(props);

  const { tagList } = props;

  return (
    <div className="search-filter-container">
      <div className="product-filter">
        <h3 className="filter-title">
          <span>
            <Icons.PcIcon />
          </span>
          プロダクトで絞り込む
        </h3>
        <InlineRadioButton
          id="product-filter"
          options={[
            {
              name: "すべて",
              value: "",
            },
            ...productList.map((product) => ({
              name: product.title,
              value: product.id,
            })),
          ]}
          value={selectedProductId ?? ""}
          onChange={handleOnProductChange}
          label={""}
          direction="column"
        />
      </div>
      <div className="tag-filter">
        <h3 className="filter-title">
          <span>
            <Icons.TagIcon />
          </span>
          タグで絞り込む
        </h3>
        <div className="tag-buttons">
          {tagList.map((tag) => (
            <label key={tag.id} className="tag-button">
              <input
                type="checkbox"
                value={tag.id}
                onChange={handleOnTagChange}
                checked={selectedTags.includes(tag.id)}
              />
              {tag.title}
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};
